import React from 'react';
import DrillLibrary from './components/DrillLibrary';

function App() {
  return (
    <div className="container mt-4">
      <h1>Mr Coach</h1>
      <DrillLibrary />
    </div>
  );
}

export default App;